import React from 'react'
import './MenuDropdownList.scss'
import PropTypes from 'prop-types'
import {GatsbyImage} from 'gatsby-plugin-image'
import {get as _get} from 'lodash'
import ExternalLink from '../../Links/ExternalLink'
import {Link} from 'gatsby-plugin-react-i18next'

const MenuDropdownList = ({items}) => {
    const renderItem = (item) => {
        return (
            <>
                {item.image && (
                    <GatsbyImage image={_get(item, 'image.childImageSharp.gatsbyImageData', '')} alt={item.title} />
                )}
                <span style={{marginLeft: '0.5rem'}}>{item.title}</span>
                <div className="menu-dropdown-list__navbar-item-description">{item.subtitle}</div>
            </>
        )
    }

    return (
        <div className="menu-dropdown-list__wrapper">
            {items.map((item) =>
                item.isExternalLink ? (
                    <ExternalLink className={'navbar-item'} href={item.href} key={item.id} noFollow={false}>
                        {renderItem(item)}
                    </ExternalLink>
                ) : (
                    <Link className="navbar-item" to={item.href} key={item.id}>
                        {renderItem(item)}
                    </Link>
                )
            )}
        </div>
    )
}

MenuDropdownList.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            image: PropTypes.object,
            title: PropTypes.string.isRequired,
            subtitle: PropTypes.string.isRequired,
            href: PropTypes.string.isRequired,
            isExternalLink: PropTypes.bool,
        })
    ),
    allPath: PropTypes.string,
}

MenuDropdownList.defaultProps = {
    items: [],
    allPath: null,
    isExternalLink: false,
}

export default MenuDropdownList
